<div *ngIf="aviso?.mensagem; else semCancelamento">

</div>
<ng-template #semCancelamento>
    <div>
        <h5>A PAC informada não possui cancelamento de saldo.</h5>
    </div>
</ng-template>